/**
 * ThoughtProcessHeader Component
 *
 * Header section for the thought process panel with title and close button
 */

import React from 'react';
import {
  Group,
  Text,
  ActionIcon,
} from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import classes from './ThoughtProcessHeader.module.css';

// =============================================================================
// COMPONENT INTERFACES
// =============================================================================

export interface ThoughtProcessHeaderProps {
  onClose: () => void;
  className?: string;
}

// =============================================================================
// MAIN COMPONENT
// =============================================================================

export const ThoughtProcessHeader: React.FC<ThoughtProcessHeaderProps> = ({
  onClose,
  className,
}) => {
  return (
    <Group justify="space-between" className={className}>
      <Text className={classes.title}>
        Thinking
      </Text>

      <ActionIcon
        variant="subtle"
        color="gray"
        size="lg"
        onClick={onClose}
        className={classes.closeButton}
        aria-label="Close thought process panel"
      >
        <IconX size={20} />
      </ActionIcon>
    </Group>
  );
};

export default ThoughtProcessHeader;
